import React from 'react';
import './storyMixerAdditionalInfo.less';

const StoryMixerAdditionalInfo = () => (
	<div className="story-mixer-info">
		<div className="container">
			<blockquote className="quote-box">
				<h1>Story Elements</h1>
					<p className="quote-text">Many different aspects of a book may catch your attention. Maybe you like an author's lush writing style or Science Fiction
					about where the good guys battle “evil corporations.” Perhaps you read contemporary romances and are interested in reading
			some time travel romances.
					</p>
					<p className="quote-text">
						NoveList calls these different aspects "story elements." Our story elements include appeal terms (like a "lush" writing style),
						themes ("evil corporations"), and genres. Each book is tagged with key story elements, making it simple to understand
			if a book is right for you, and to search for similar books.
					</p>
			</blockquote>

			<h2>Appeal</h2>
				<p>Appeal factors describe a book's "feel," and help you decide if a book fits what you’re in the mood to read. NoveList's
		appeal factors cover all aspects of a book, including types of characters in a story, the pace, the writing style, and
		the tone of the story. For picture books, graphic novels, and other books with illustrations, we also offer illustration
	appeal. Audiobook fans can find information about a narration under "Audio Characteristics."</p>
				<p>
					<a href="https://help.ebsco.com/interfaces/NoveList_Products/Story_Elements/Appeal_Terms" target="_blank" rel="noopener noreferrer">You'll find a complete list of our appeal terms here</a>.
				</p>

				<h2>Theme</h2>
					<p>Themes describe the overall plot of a novel, especially those themes that are common within a certain genre or for a certain
				age range. For example, a common plot in Christian Fiction centers around the "prodigal returns," while there are many
				fantasy novels that explore what it means for someone to be the "last of their kind." Some popular mainstream fiction
				themes include stories with a "fish out of water" or about "life during wartime." Many children's stories center on "overcoming
	fear" or "families in conflict." </p>

					<p>Want to check for your favorite theme? <a href="https://help.ebsco.com/interfaces/NoveList_Products/Story_Elements/Theme_Terms"
				target="_blank" rel="noopener noreferrer">We have a complete list of themes, definitions, and the appropriate age ranges here</a>.</p>

			<h2>Genre</h2>
				<p>Genre headings like "police procedurals" and "road novels" will help you explore your favorite genre in more depth, as
			well as explore new-to-you genres.
				<a href="https://help.ebsco.com/interfaces/NoveList_Products/Story_Elements/Genre_Terms" target="_blank" rel="noopener noreferrer">You'll find a complete list of genre headings used and the age ranges they are used with here</a>.
				</p>
		</div>
	</div>
);

export default StoryMixerAdditionalInfo;



// WEBPACK FOOTER //
// ./src/react/views/storyMixer/StoryMixerAdditionalInfo.jsx